var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.parsedContent && _vm.parsedContent.children.length)?_c('div',_vm._l((_vm.parsedContent.children),function(child,i){return _c('div',[_c('ContentTypeFactory',{key:i,attrs:{"data":child}})],1)}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }